
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 28 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.521 22.917a1.458 1.458 0 012.916 0v7.479c0 .805-.653 1.458-1.458 1.458H1.458A1.458 1.458 0 010 30.396v-7.479a1.458 1.458 0 012.916 0v6.021H25.52v-6.021z"}}),_c('path',{attrs:{"d":"M15.608 18.985l7.146-7.219a1.46 1.46 0 012.073 2.053l-9.652 9.753a1.458 1.458 0 01-2.493-1.027v-.005l.066-20.94a1.458 1.458 0 012.916.004v.005l-.055 17.378z"}}),_c('path',{attrs:{"d":"M15.183 21.526a1.459 1.459 0 01-2.089 2.037l-9.49-9.733a1.459 1.459 0 012.089-2.037l9.49 9.733z"}})])
          )
        }
      }
    